export class ProductSelectorComponent {
}
